import { useAuthStore, useCaseStore } from '../../../../store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { useCaseApi } from '../../../../apiHooks';
import { useEffect, useState } from 'react';
import { useSort } from '../../../../hooks/useSort';
import { generateLink, PublishUserLink } from '../../../../utils';
import { RoleFunction } from '../../../../constants/projectUsers';
import { DiseaseType } from '../../../../interfaces/common/common';

export const useComments = () => {
  const navigate = useNavigate();
  const { comments, status } = useCaseStore();
  const { roleFunction } = useAuthStore();
  const { type, id, version } = useParams();
  const { getComments } = useCaseApi();

  const [idComment, setIdComment] = useState<number | null>(null);

  const { items } = useSort(comments, ['dateWithHour'], 'DESC');

  const isCommentNull = comments === null;

  useEffect(() => {
    void getComments(String(type), Number(id), isCommentNull, version);
  }, [type, id, getComments, isCommentNull, version]);

  useEffect(() => {
    if (items?.length > 0) {
      setIdComment(items[0].id);
    }
  }, [items]);

  const handleEdit = () => {
    navigate(
      generateLink(
        RoleFunction.ROLE_PUBLISHING,
        version ? PublishUserLink.CASE_EDIT_CUSHINGV2 : PublishUserLink.CASE_EDIT,
        version === 'v2'
          ? [
              [':type', type as DiseaseType],
              [':version', version as string],
              [':id', Number(id)]
            ]
          : [
              [':type', type as DiseaseType],
              [':id', Number(id)]
            ]
      )
    );
  };

  const emptyMessage = comments !== null && items.length === 0 ? 'Brak uwag do opisu przypadku medycznego.' : null;
  return {
    items,
    idComment,
    type,
    roleFunction,
    handleEdit,
    status,
    emptyMessage
  };
};
